<template>
  <div style="
      background: #12102e;
      min-height: 100vh;
      height: auto;
      padding-bottom: 15rem;
    ">
    <div
      class="login-cont container"
      style="height: 80vh"
    >
      <div class="d-flex justify-content-center">
        <div class="col-12 px-0 d-flex flex-column my-auto">
          <img
            class="mx-auto object-contain cursor-pointer"
            src="/logo.png"
            alt=""
            @click="$router.push('/home')"
            style="height: 15rem"
          />
          <!-- <div class="card border-0 mb-0 auth-card bg-transparent"> -->
          <div class="card-body px-2 d-flex py-0 mx-0 col-12 mx-auto">
            <div class="my-auto col-12">
              <div class="text-center mb-4">
                <div
                  class="error text-white text-center py-2"
                  v-if="error"
                >
                  <span class="mx-auto">
                    {{ $t("auth.fail_message") }}
                  </span>
                </div>
              </div>
              <form role="form">
                <small
                  class="text-danger my-3"
                  style="color: rgb(240 97 38 / 1) !important"
                >{{ errors.phone }}</small>
                <div class="form-group mb-3">
                  <label style="
                      color: white;
                      font-weight: 550;
                      letter-spacing: 0.5px;
                    ">{{ $t("auth.username") }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative bg-transparent"
                    > -->
                  <div
                    class="flex items-center gap-2 mt-2 h-[53px] rounded-[10px] px-3"
                    style="background: hsla(0, 0%, 100%, 0.1)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                      />
                    </svg>
                    <input
                      type="text"
                      v-model="name"
                      class="text-lg text-white w-100"
                      @keyup.enter="focusOnPasswordInputBox"
                    />
                  </div>
                  <!-- </div> -->
                </div>
                <small
                  class="text-danger my-3"
                  style="color: rgb(240 97 38 / 1) !important"
                >{{ errors.password }}</small>
                <div class="form-group pt-3">
                  <label style="
                      color: white;
                      font-weight: 550;
                      letter-spacing: 0.5px;
                    ">{{ $t("auth.password") }}</label>
                  <!-- <div
                      class="input-group input-group-merge input-group-alternative"
                    > -->
                  <div
                    class="flex relative items-center gap-2 mt-2 h-[53px] rounded-[10px] px-3"
                    style="background: hsla(0, 0%, 100%, 0.1)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                    >
                      <path
                        fill="currentColor"
                        d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                      />
                    </svg>
                    <input
                      type="password"
                      ref="password"
                      v-model="password"
                      @keyup.enter="loginWithPhone"
                      class="text-lg text-white w-100"
                    />
                    <i
                      class="far fa-eye showable-password"
                      v-if="isShow"
                      @click="showablePassword()"
                    ></i>
                    <i
                      v-if="!isShow"
                      class="fas fa-eye-slash showable-password"
                      @click="showablePassword()"
                    ></i>
                  </div>

                  <!-- </div> -->
                </div>

                <div class="pl-0">
                  <input
                    type="checkbox"
                    class="mr-2"
                    v-model="isRememberMe"
                  />
                  <label for="customCheckLogin">
                    <b class="text-muted">
                      {{ $t('auth.remember_me') }}
                    </b>
                  </label>
                </div>

                <div class="text-center mt-3">
                  <button
                    type="button"
                    class="bg-gradient-to-l text-white !text-[20px] from-[#924aff] to-[#4f3ffd] w-full !rounded-full py-3"
                    @click="loginWithPhone()"
                  >
                    <div v-if="!isSignin">
                      {{ $t("auth.login") }}
                    </div>

                    <Loading
                      color="#fff"
                      v-if="isSignin"
                      size="24"
                      class="px-4 py-0"
                    />
                  </button>
                </div>
                <!-- <div class="col-12 d-flex my-1">
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div> 
                      <div class="my-auto text-dark px-3">OR</div>
                      <div class="col-5 p-0 my-auto" style="border-top: 1px solid white; height: 0;"></div>
                    </div>
                    <div class="text-center mb-3">
                      <button
                        type="button"
                        class="btn my-4"
                        style="background: #10A931; color: white; border-radius: 20px; width: 14rem; box-shadow: none;"
                        @click="$router.push('/auth/register')"
                      >
                        <div>
                          {{$t('auth.sign_up')}}
                        </div>
                      </button>
                    </div> -->
                <!-- <div class="d-flex justify-content-center">
                      <span style="color: #ffffff; text-decoration: underline;" @click="$router.push('/auth/not-auth-verify')">Forgot Password?</span>
                    </div> -->
              </form>
            </div>
          </div>
          <!-- </div> -->
          <div class="row mt-3">
            <div class="col-4">
              <div
                class="modal fade"
                id="forgetPassword"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modal-form"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal- modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-body p-5">
                      <b>
                        Please direct contact to customer service -
                        <span class="text-dark">09756477723</span>
                      </b>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Loading } from "vant";
import { mapActions } from "vuex";
// import { loadTawk, showTawk } from '@/utils/tawk';

export default {
  components: { Loading },
  data() {
    return {
      name: null,
      password: null,
      error: false,
      errors: {},
      isSignin: false,
      isShow: false,
      isRememberMe: false,
    };
  },
  methods: {
    ...mapActions(["fetchUser"]),
    async getAgentContact() {
      try {
        const res = await this.axios.post("/user/agentcontact", {},
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
          }
        );
        this.$store.commit('setAgentContact', res.data.data);
      } catch (e) {
        this.$store.commit('setAgentContact', null);
      }
    },

    showablePassword() {
      if (this.isShow) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
      this.isShow = !this.isShow;
    },
    focusOnPasswordInputBox() {
      this.$refs.password.focus();
    },
    /**
     * login with phone
     */
    async loginWithPhone() {
      this.isSignin = true;
      this.errors = {};
      if (!this.name) {
        this.errors.name = this.$t("auth.require_username");
        this.isSignin = false;
        return false;
      }
      if (!this.password) {
        this.errors.password = this.$t("auth.require_password");
        this.isSignin = false;
        return false;
      }
      try {
        // if (this.name === 'testuser') {
        //   window.open('https://about.myanmarsoccer.xyz', '_self');
        // } else {
        const res = await this.axios.post("/auth/login", {
          name: this.name,
          password: this.password,
          roles: "normal",
          // fcm: localStorage.getItem('fcm'),
        });

        if (this.isRememberMe) {
          localStorage.setItem("username", this.name);
          localStorage.setItem("password", this.password);
        } else {
          localStorage.removeItem("username");
          localStorage.removeItem("password");
        }

        localStorage.setItem("token", res.data.token);

        const currentTime = new Date();
        localStorage.setItem(
          "tokenExpire",
          new Date(currentTime.getTime() + 60 * 60 * 1000)
        );
        await this.fetchUser();
        this.getAgentContact();
        this.$router.push("/home");
        // this.$router.go();

        // const user = JSON.parse(localStorage.getItem('userData'));
        // loadTawk(user);
        // showTawk();

        // ..
        Toast.success(
          this.$store.state.language === "en" ? "Success!" : "Success!"
        );
        // }
      } catch (err) {
        this.error = true;
      }
      this.isSignin = false;
      return true;
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (authUser && this.$store.state.authUser.roles === "normal")
      this.$router.push("/home");
    const userName = localStorage.getItem("username");
    const password = localStorage.getItem("password");
    if (userName && password) {
      this.name = userName;
      this.password = password;
    }
  },
};
</script>

<style scoped>
.custom-input:active,
.custom-input:focus {
  border: 1px solid #d6e2f4 !important;
}

.login-cont {
  padding-top: 3rem;
}

.showable-password {
  position: absolute;
  right: 15px;
  top: 20px;
  cursor: pointer;
  z-index: 1000;
  color: #ebab0b;
}

.new-account-text {
  cursor: pointer;
}

.error {
  margin-bottom: 13px;
  /* height: 40px; */
  display: flex;
  align-items: center;
  color: white;
  border-radius: 0.5rem;
  padding: 0px 15px;
  background: #000000 !important;
  border: 1px solid rgb(240 97 38 / 1) !important;
  box-shadow: none !important;
}

.auth-card {
  background: #eeecec;
  /* color: black */
}
</style>
